module.exports = __webpack_public_path__ + "static/lady-does-yoga-1f0a1073f3d00a98fb2fdc6c26ce35c5.jpg";